/* House of Ovelle — loads ovelle-color.js (colour swatches + per-colour gallery)
   and ovelle-cart-options.{css,js} (in-cart size / purchase-option switching).
   Lives here because this file already loads on every page; the loader sits
   above the motion IIFE so it still runs under prefers-reduced-motion.

   NOTE: these are loaded by hand, so they do not get Liquid's asset_url cache
   key. Bump CART_OPTIONS_V whenever ovelle-cart-options.js or .css changes,
   otherwise browsers and the CDN keep serving the previous copy.
   Same for CART_POLISH_V (ovelle-cart-polish.*) and CART_SUB_V
   (ovelle-cart-sub.css + ovelle-sub-info.js, the Subscribe & Save switch). */
(function () {
  var CART_OPTIONS_V = '13';

  var ref = document.querySelector('script[src*="ovelle-motion.js"]');
  if (!ref) return;
  var base = ref.src.split('?')[0];
  var query = ref.src.indexOf('?') > -1 ? ref.src.slice(ref.src.indexOf('?')) : '';

  var s = document.createElement('script');
  s.src = base.replace('ovelle-motion.js', 'ovelle-color.js') + query;
  s.defer = true;
  document.head.appendChild(s);

  var bust = (query ? query + '&' : '?') + 'ovc=' + CART_OPTIONS_V;

  var c = document.createElement('script');
  c.src = base.replace('ovelle-motion.js', 'ovelle-cart-options.js') + bust;
  c.defer = true;
  document.head.appendChild(c);

  var l = document.createElement('link');
  l.rel = 'stylesheet';
  l.href = base.replace('ovelle-motion.js', 'ovelle-cart-options.css') + bust;
  document.head.appendChild(l);

  /* motion extras — hover, press, focus, image fade-in, nav progress.
     Same hand-loaded pattern, so bump MOTION_EXTRA_V when either file changes. */
  var MOTION_EXTRA_V = '3';
  var xbust = (query ? query + '&' : '?') + 'ovx=' + MOTION_EXTRA_V;

  var xl = document.createElement('link');
  xl.rel = 'stylesheet';
  xl.href = base.replace('ovelle-motion.js', 'ovelle-motion-extra.css') + xbust;
  document.head.appendChild(xl);

  var xs = document.createElement('script');
  xs.src = base.replace('ovelle-motion.js', 'ovelle-motion-extra.js') + xbust;
  xs.defer = true;
  document.head.appendChild(xs);

  /* cart polish — summary fold, purchase-option rows, upsell sheet */
  var CART_POLISH_V = '6';
  var pbust = (query ? query + '&' : '?') + 'ovp=' + CART_POLISH_V;

  var pl = document.createElement('link');
  pl.rel = 'stylesheet';
  pl.href = base.replace('ovelle-motion.js', 'ovelle-cart-polish.css') + pbust;
  document.head.appendChild(pl);

  var ps = document.createElement('script');
  ps.src = base.replace('ovelle-motion.js', 'ovelle-cart-polish.js') + pbust;
  ps.defer = true;
  document.head.appendChild(ps);

  /* site polish — set card v2, announcement marquee, footer folds */
  var SITE_POLISH_V = '3';
  var sbust = (query ? query + '&' : '?') + 'ovs=' + SITE_POLISH_V;

  var sl = document.createElement('link');
  sl.rel = 'stylesheet';
  sl.href = base.replace('ovelle-motion.js', 'ovelle-site-polish.css') + sbust;
  document.head.appendChild(sl);

  var ss = document.createElement('script');
  ss.src = base.replace('ovelle-motion.js', 'ovelle-site-polish.js') + sbust;
  ss.defer = true;
  document.head.appendChild(ss);

  /* loaded last so it wins the ties it needs to */
  var fl = document.createElement('link');
  fl.rel = 'stylesheet';
  fl.href = base.replace('ovelle-motion.js', 'ovelle-cart-fix.css') + sbust;
  document.head.appendChild(fl);

  /* Subscribe & Save switch on bag lines and in the upsell sheet — after the fix sheet */
  var CART_SUB_V = '8';
  var ubust = (query ? query + '&' : '?') + 'ovb=' + CART_SUB_V;
  var ul = document.createElement('link');
  ul.rel = 'stylesheet';
  ul.href = base.replace('ovelle-motion.js', 'ovelle-cart-sub.css') + ubust;
  document.head.appendChild(ul);

  /* the (i) perks dialog next to Subscribe & Save — same version key */
  var us = document.createElement('script');
  us.src = base.replace('ovelle-motion.js', 'ovelle-sub-info.js') + ubust;
  us.defer = true;
  document.head.appendChild(us);
})();

/* House of Ovelle — motion helpers (v1.3.4)
   Runs before ovelle.js (which owns the .ov-reveal observer) so the extra
   reveal targets it adds are picked up by that observer.
   - Adds .ov-reveal to grids that didn't have it (collection cards, compare, pairs, membership, builder)
   - Sets --ov-i on sibling reveals so CSS can stagger them
   - Subtle parallax on hero and image-band media
*/
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  var EXTRA = '#product-grid > li, .ov-compare__product, .ov-pairs__item, .ov-member__item, .ov-builder__card, .ov-key, .ov-layer, .ov-meter, .ov-faq__item';
  document.querySelectorAll(EXTRA).forEach(function (el) {
    // don't nest reveals inside a text-stagger parent that already animates its children
    if (el.parentElement && el.parentElement.classList.contains('ov-reveal')) return;
    el.classList.add('ov-reveal');
  });

  // Stagger index among siblings that reveal together (wraps so long grids don't lag)
  var parents = new Set();
  document.querySelectorAll('.ov-reveal').forEach(function (el) { if (el.parentElement) parents.add(el.parentElement); });
  parents.forEach(function (parent) {
    var kids = Array.prototype.filter.call(parent.children, function (c) { return c.classList.contains('ov-reveal'); });
    if (kids.length < 2) return;
    kids.forEach(function (k, i) { k.style.setProperty('--ov-i', String(i % 6)); });
  });

  // Parallax: media drifts at a fraction of the container's travel through the viewport
  var layers = Array.prototype.slice.call(document.querySelectorAll('.ov-hero__media, .ov-band__media'));
  if (!layers.length) return;
  var ticking = false;
  function update() {
    ticking = false;
    var vh = window.innerHeight || 1;
    layers.forEach(function (el) {
      var host = el.parentElement || el;
      var r = host.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var progress = (r.top + r.height / 2 - vh / 2) / vh; // -1 .. 1
      progress = Math.max(-1, Math.min(1, progress));
      var k = el.classList.contains('ov-hero__media') ? 0.045 : 0.07;
      el.style.transform = 'translate3d(0,' + (progress * -k * r.height).toFixed(1) + 'px,0)';
    });
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();
